import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const RSVNeedOfTest = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    When Do You Need an RSV Test In Chicago?
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='py-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Your doctor probably won’t order RSV testing in Chicago if you have symptoms but are otherwise healthy. Most healthy people and children with RSV will recover in one to two weeks. To alleviate your symptoms, your doctor may suggest taking prescription medications and drinking plenty of fluids. Before giving your child any medicines, talk to the person caring for them.
                </div>
            </div>

            <div className=''>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Infants, young children, and older adults may require hospital treatment if someone has breathing problems or has lost too much fluid and become dehydrated. Oxygen and fluids administered via IV may be part of the treatment. A ventilator, a breathing apparatus, may be required in the most severe cases, but this is uncommon.
                </div>
            </div>

            <div className='pt-md-5 pt-4 left-padding6rem right-padding6rem mb-4'>
            <div className='left-padding6rem0 right-padding6rem0' style={{ }}>
                <div className='bg-img rounded30 pt-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("sti-testing/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='p-4'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            Ultimate Destination for Lab Testing In Chicago
                            <hr className='hr-style my-md-2' style={{ width:'120px', marginTop:'2px', marginBottom:'4px'}}/>
                        </center>
                    </text>    
                    </div>

                    <div className='pb-4 pt-md-'>
                        <center>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    Book Appointment
                                </text>
                            </Button>
                        </Link>
                        </center>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default RSVNeedOfTest